import { CALL_API } from '../middleware/api';

// Action Types
export const DISCOUNTCODES_REQUEST = 'DISCOUNTCODES_REQUEST';
export const DISCOUNTCODES_SUCCESS = 'DISCOUNTCODES_SUCCESS';
export const DISCOUNTCODES_FAILURE = 'DISCOUNTCODES_FAILURE';

export const DISCOUNTCODE_REQUEST = 'DISCOUNTCODE_REQUEST';
export const DISCOUNTCODE_SUCCESS = 'DISCOUNTCODE_SUCCESS';
export const DISCOUNTCODE_FAILURE = 'DISCOUNTCODE_FAILURE';

export const DISCOUNTCODE_ADD_REQUEST = 'DISCOUNTCODE_ADD_REQUEST';
export const DISCOUNTCODE_ADD_SUCCESS = 'DISCOUNTCODE_ADD_SUCCESS';
export const DISCOUNTCODE_ADD_FAILURE = 'DISCOUNTCODE_ADD_FAILURE';

export const DISCOUNTCODE_UPDATE_REQUEST = 'DISCOUNTCODE_UPDATE_REQUEST';
export const DISCOUNTCODE_UPDATE_SUCCESS = 'DISCOUNTCODE_UPDATE_SUCCESS';
export const DISCOUNTCODE_UPDATE_FAILURE = 'DISCOUNTCODE_UPDATE_FAILURE';

export const DISCOUNTCODE_DELETE_REQUEST = 'DISCOUNTCODE_DELETE_REQUEST';
export const DISCOUNTCODE_DELETE_SUCCESS = 'DISCOUNTCODE_DELETE_SUCCESS';
export const DISCOUNTCODE_DELETE_FAILURE = 'DISCOUNTCODE_DELETE_FAILURE';

export const DISCOUNTCODE_RESET = 'DISCOUNTCODE_RESET';

// Action Creators
export function fetchDiscountCodes() {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: 'discountcodes',
      authenticated: true,
      types: [DISCOUNTCODES_REQUEST, DISCOUNTCODES_SUCCESS, DISCOUNTCODES_FAILURE]
    }
  };
}

export function fetchDiscountCode(id) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `discountcodes/${id}`,
      authenticated: true,
      types: [DISCOUNTCODE_REQUEST, DISCOUNTCODE_SUCCESS, DISCOUNTCODE_FAILURE]
    }
  };
}

export function createDiscountCode(discountCodeData) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'discountcodes',
      body: JSON.stringify(discountCodeData),
      authenticated: true,
      types: [DISCOUNTCODE_ADD_REQUEST, DISCOUNTCODE_ADD_SUCCESS, DISCOUNTCODE_ADD_FAILURE]
    }
  };
}

export function updateDiscountCode(id, discountCodeData) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `discountcodes/${id}`,
      body: JSON.stringify(discountCodeData),
      authenticated: true,
      types: [DISCOUNTCODE_UPDATE_REQUEST, DISCOUNTCODE_UPDATE_SUCCESS, DISCOUNTCODE_UPDATE_FAILURE]
    }
  };
}

export function deleteDiscountCode(id) {
  return {
    [CALL_API]: {
      method: 'DELETE',
      endpoint: `discountcodes/${id}`,
      authenticated: true,
      types: [DISCOUNTCODE_DELETE_REQUEST, DISCOUNTCODE_DELETE_SUCCESS, DISCOUNTCODE_DELETE_FAILURE]
    }
  };
}

export function fetchAvailableDiscountCodes(customerId) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `discountcodes/available/${customerId}`,
      authenticated: true,
      types: [DISCOUNTCODES_REQUEST, DISCOUNTCODES_SUCCESS, DISCOUNTCODES_FAILURE]
    }
  };
}

export function resetDiscountCode() {
  return {
    type: DISCOUNTCODE_RESET
  };
}